
import { useI18n } from 'vue-i18n'

export class DataUtils {
  public static getType(type) {
    const { t } = useI18n()
    const TYPESTR = [
      "",
      t('match.matchjq'),
      t('match.matchjqs'),
      t('match.matchhp2'),
      t('match.matchhp'),
      t('match.matchjwq'),
      t('match.matchryq'),
      t('match.matchqmq'),
      t('match.matchdq'),
      t('match.matchhr'),
      t('match.matchbsks'),
      t('match.matchzc'),
      t('match.matchjsg'),
      t('match.matchbcbf'),
      t('match.matchlhbh'),
      t('match.matchdqwj'),
      t('match.matchwlq'),
      t('match.matchstbs'),
      t('match.matchsz'),
      t('match.matchsp'),
      t('match.matchzg'),
      t('match.matchwxjg'),
      t('match.matchkql'),
      t('match.matchjssjs'),
      t('match.matchjdqdz'),
      "VAR",
    ];
    return TYPESTR[type] ? TYPESTR[type] : "";
  }
}
